import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { SmartbannerComponent } from './containers/smartbanner/smartbanner.component';
import { smartbannerTranslation } from './i18n/fr';

@NgModule({
    imports: [BrowserModule, CommonModule, RouterModule, TranslateModule],
    declarations: [SmartbannerComponent],
    exports: [SmartbannerComponent],
})
export class SmartbannerModule {
    public constructor(translate: TranslateService) {
        translate.setTranslation('fr', smartbannerTranslation, true);
    }
}
